import styled from "styled-components";

export const ChartToggle = styled.div`
	span {
		font-size: 10px;
		font-weight: 600;
		line-height: 10px;
	}
`;
